export const flag = {
    boolean: (value: boolean): BooleanFlag => ({
        type: "boolean",
        options: [true, false],
        defaultValue: value,
    }),
    enum: <T extends string>(
        options: T[],
        defaultValue?: NoInfer<T>,
    ): EnumFlag<T> => ({
        type: "enum",
        options: options,
        defaultValue: defaultValue,
    }),
};

type BooleanFlag = {
    type: "boolean";
    options: boolean[];
    defaultValue: boolean;
};
type EnumFlag<T extends string> = {
    type: "enum";
    options: T[];
    defaultValue?: NoInfer<T>;
};
